import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Milestones is hidden for now. Each tab reads its badge count from the
// `metrics` object returned by the list APIs (keyed by metricKey).
const TABS = [
  {
    label: 'Work Orders',
    value: 'purchase-order',
    path: '/purchase-order',
    metricKey: 'purchase_orders',
  },
  {
    label: 'Proforma Invoices',
    value: 'proforma-invoices',
    path: '/proforma-invoices',
    metricKey: 'proforma_invoices',
  },
  {
    label: 'Invoices',
    value: 'invoices',
    path: '/invoices',
    metricKey: 'invoices',
  },
  {
    label: 'Credit Notes',
    value: 'credit-notes',
    path: '/credit-notes',
    metricKey: 'credit_notes',
  },
];

const getActiveTab = (pathname) => {
  if (pathname.includes('/purchase-order')) return 'purchase-order';
  if (pathname.includes('/proforma-invoices')) return 'proforma-invoices';
  if (pathname.includes('/credit-notes')) return 'credit-notes';
  if (pathname.includes('/milestones')) return 'milestones';
  if (pathname.includes('/invoices')) return 'invoices';
  return 'purchase-order';
};

const BillingTabs = ({ metrics }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeTab = getActiveTab(pathname);

  return (
    <div className="flex items-center mb-5">
      {TABS.map((tab) => {
        const isActive = activeTab === tab.value;
        const count = metrics?.[tab.metricKey];
        return (
          <button
            key={tab.value}
            type="button"
            onClick={() => navigate(tab.path)}
            className={[
              'inline-flex items-center gap-[7px] px-5 py-2.5 text-[13px]',
              'border-b-2 -mb-px transition-colors bg-transparent border-l-0 border-r-0 border-t-0',
              'font-[inherit] cursor-pointer whitespace-nowrap',
              isActive
                ? 'text-primary font-semibold border-primary'
                : 'text-muted-foreground font-medium border-transparent hover:text-muted-foreground',
            ].join(' ')}
          >
            {tab.label}
            {count !== undefined && (
              <span
                className={[
                  'text-[11px] font-semibold px-[7px] py-[1px] rounded-[10px] leading-[1.5]',
                  isActive
                    ? 'bg-brand-bg-subtle text-primary'
                    : 'bg-border text-muted-foreground',
                ].join(' ')}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default BillingTabs;
